import templateUrl from './shippingParcel.operationDetails.html'

/**
 * Builds a row of the table of parcel items for the Parcel View component
 */
export const tmrShippingParcelOperationDetails = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrShippingParcelOperationDetailsController',
  bindings: {
    operationParcel: '<',
    details: '<',
  },
}

/**
 * Controller of component {@link tmrShippingParcelOperationDetails}.
 *
 * @type {ngController}
 */
export class tmrShippingParcelOperationDetailsController {
  static ngType = 'controller'

  constructor($mdDialog) {
    'ngInject'
    Object.assign(this, { $mdDialog })
  }

  parcelRowDetailsModal(targetEvent, row) {
    this.$mdDialog.show(
      this.$mdDialog.tmrShippingOperationEntries({
        targetEvent,
        locals: {
          shippingOperationParcel: this.operationParcel,
          code: row.code,
          description: row.description,
          color: row.color,
          size: row.size,
        },
      })
    )
  }
}
